import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { AmbarVoyageService } from "../../../services/AmbarVoyageService";
import { GetAmbarVoyageByIdResponse, GetAmbarVoyageByIdResponseAmbar } from "../../../models/response/ambarVoyage/GetAmbarVoyageByIdResponse";
import { AddAmbarVoyageRequest } from "../../../models/request/ambarVoyage/AddAmbarVoyageRequest";
import { AddAmbarVoyageResponse } from "../../../models/response/ambarVoyage/AddAmbarVoyageResponse";
import GeneralInformation from "./Components/GeneralInformation";
import Orders from "./Components/Orders";

const AmbarVoyageAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Nakliye > Seferler"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [ambarVoyageId, setAmbarVoyageId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedVehicle, setSelectedVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedTrailer, setSelectedTrailer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSupplier, setSelectedSupplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [endDateStr, setEndDateStr] = useState<string | null | undefined>(undefined);
    const [selectedPricingVehicleType, setSelectedPricingVehicleType] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [ambars, setAmbars] = useState<GetAmbarVoyageByIdResponseAmbar[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetAmbarVoyageByIdResponse = await AmbarVoyageService.getAmbarVoyageById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAmbarVoyageId(response.data.ambarVoyageId);
                setRefNo(response.data.refNo);

                if (response.data.vehicleId && response.data.vehicleName)
                    setSelectedVehicle({ label: response.data.vehicleName, value: response.data.vehicleId });

                if (response.data.trailerId && response.data.trailerName)
                    setSelectedTrailer({ label: response.data.trailerName, value: response.data.trailerId });

                if (response.data.driverId && response.data.driverName)
                    setSelectedDriver({ label: response.data.driverName, value: response.data.driverId });

                if (response.data.supplierId && response.data.supplierName)
                    setSelectedSupplier({ label: response.data.supplierName, value: response.data.supplierId });

                setIsCustomActive(response.data.isCustomActive);
                setEndDateStr(response.data.endDateStr);

                if (response.data.pricingVehicleTypeId && response.data.pricingVehicleTypeName)
                    setSelectedPricingVehicleType({ label: response.data.pricingVehicleTypeName, value: response.data.pricingVehicleTypeId });

                setAmbars(Helpers.sortListByProperty(response.data.ambars.map(function (x, i) {
                    x.ambarVoyageOrder = (i + 1);
                    return x;
                }), "ambarVoyageOrder"));
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveAmbarVoyage = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var obj: AddAmbarVoyageRequest = {
                ambarVoyageId: ambarVoyageId,
                refNo: refNo,
                driverId: selectedDriver?.value,
                isCustomActive: isCustomActive,
                pricingVehicleTypeId: selectedPricingVehicleType?.value,
                supplierId: selectedSupplier?.value,
                trailerId: selectedTrailer?.value,
                vehicleId: selectedVehicle?.value,
                ambars: ambars.map(function (x) {
                    return {
                        ambarId: x.ambarId,
                        ambarVoyageOrder: x.ambarVoyageOrder,
                        elleIlkSira: !!x.elleIlkSira
                    }
                })
            }

            var response: AddAmbarVoyageResponse = await AmbarVoyageService.addAmbarVoyage(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <GeneralInformation
                        ambarVoyageId={ambarVoyageId}
                        endDateStr={endDateStr}
                        setEndDateStr={setEndDateStr}
                        isCustomActive={isCustomActive}
                        selectedPricingVehicleType={selectedPricingVehicleType}
                        setSelectedPricingVehicleType={setSelectedPricingVehicleType}
                        refNo={refNo}
                        selectedDriver={selectedDriver}
                        selectedSupplier={selectedSupplier}
                        selectedTrailer={selectedTrailer}
                        selectedVehicle={selectedVehicle}
                        setIsCustomActive={setIsCustomActive}
                        setRefNo={setRefNo}
                        setSelectedDriver={setSelectedDriver}
                        setSelectedSupplier={setSelectedSupplier}
                        setSelectedTrailer={setSelectedTrailer}
                        setSelectedVehicle={setSelectedVehicle}
                    />

                    <Orders
                        ambarVoyageId={ambarVoyageId}
                        ambars={ambars}
                        setAmbars={setAmbars}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveAmbarVoyage}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default AmbarVoyageAdd;